module.exports = __webpack_public_path__ + "static/media/origional_me.af0d37bd.jpg";